import React from "react";
import "./BSUPatientHeader.scss";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { useTypedSelector } from "hooks/store";

type ComponentProps = {
    title: string;
};

const BSUPatientHeader = ({ title }: ComponentProps): JSX.Element => {
    const currentDrawerType = useTypedSelector((store) => store.ModelWindow.type);
    return (
        <section className="bsuPatientHeaderMobile">
            <DrawerGoBackComponent type={currentDrawerType} classes={""} isIcon={true} />
            <h2>{title}</h2>
            <DrawerRemoveObjectComponent
                classes={""}
                type={currentDrawerType}
                payload={""}
                icon={true}
            />
        </section>
    );
};

export default BSUPatientHeader;
